import { cn } from '@/lib/utils'

function ShimmerBlock({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'rounded-md bg-panel-elevated bg-[length:1000px_100%] bg-no-repeat animate-shimmer motion-reduce:animate-none',
        className
      )}
      style={{
        backgroundImage:
          'linear-gradient(90deg, rgb(var(--jd-panel-elevated)) 0%, rgb(var(--jd-border)) 50%, rgb(var(--jd-panel-elevated)) 100%)',
      }}
    />
  )
}

export function SkeletonCard() {
  return (
    <div className="card space-y-3">
      <div className="flex items-center justify-between">
        <ShimmerBlock className="h-3 w-24" />
        <ShimmerBlock className="h-4 w-12" />
      </div>
      <ShimmerBlock className="h-4 w-3/4" />
      <ShimmerBlock className="h-3 w-1/2" />
      <div className="grid grid-cols-3 gap-2 pt-1">
        <ShimmerBlock className="h-8" />
        <ShimmerBlock className="h-8" />
        <ShimmerBlock className="h-8" />
      </div>
    </div>
  )
}

export function SkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  )
}
